module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0068.jpg?v=c1f252b3";